import { Component } from '@angular/core';
import * as $ from 'jquery';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  user: any;
  constructor(private AuthService: AuthService) {
    
   }

  ngOnInit(): void {
      $('#sidebarCollapse').on('click', function () {
      //console.log('Test')
      // alert('Test')
                $('#sidebar').toggleClass('active');
            });   
    //         this.AuthService.getUserSession()
    // .subscribe(data => {
    //     this.user = data.slice(0);
        
    // });
   }
  title = 'app';
  isCollapsed = false;
  isReverseArrow = false;
  width = 200;
}
